import style from '../../assets/scss/index.scss?inline';

export const sheet = new CSSStyleSheet();
sheet.replaceSync(style);
